export default {
  ScreenCommon: {
    Selected: 'Đã chọn:',
    SelectedAll: 'Chọn tất',
    UnSelectedAll: 'Bỏ chọn',
    BatchExcution: 'Thực hiện hàng loạt',
    Filter: 'Lọc',
    Add: 'Thêm',
    Duplicate: 'Nhân bản',
    EditView: 'Xem/Sửa',
    PrintRecover: 'In phục hồi',
    SeeRejectReport: 'Xem lý do từ chối',
    DownloadVoucher: 'Tải chứng từ báo nợ',
    ViewVoucher: 'Xem chứng từ',
    GenerateAccounting: 'Sinh hạch toán',
    GenerateVoucherBH: 'Sinh hạch toán lương, bảo hiểm',
    ChooseVoucher: 'Chọn mẫu chứng từ',
    View: 'Xem',
    Edit: 'Sửa',
    Sign: 'Ký',
    AddSigner: 'Thêm người ký',
    RejectSigning: 'Từ chối ký',
    Revoke: 'Thu hồi',
    Complete: 'Hoàn thành',
    Delete: 'Xóa',
    ActionColumn: 'Chức năng',
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
    Refresh: 'Lấy lại dữ liệu',
    Print: 'In',
    Help: 'Trợ giúp',
    Guide: 'Hướng dẫn',
    SettingLayout: 'Tùy chỉnh giao diện',
    ImportExcel: 'Nhập khẩu từ Excel',
    Export: 'Xuất khẩu',
    Extention: 'Tiện ích',
    Address: 'Địa chỉ',
    Description: 'Diễn giải',
    Load: 'Nạp',
    NotPosted: 'Chưa ghi sổ',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi',
    ShortKeys: 'Phím tắt',
    Email: 'Email',
    CustomizeLayout: 'Tùy chỉnh giao diện',
    TotalAmount: 'Tổng tiền',
    GeneralInfo: 'Thông tin chung',
    EditKey: 'Sửa (Ctrl + E)',
    PostponeKey: 'Hoãn (Ctrl + U)',
    SaveKey: 'Cất (Ctrl + S)',
    CloseKey: 'Đóng (ESC)',
    CancelKey: 'Hủy',
    Accept: 'Đồng ý (Ctrl + S)',
    RefreshTooltip: 'Nạp (Ctrl + R)',
    AddTooltip: 'Thêm (Ctrl + 1)',
    PrintTooltip: 'In (Ctrl + I)',
    BackTooltip: 'Trước (Ctrl + F7)',
    NextTooltip: 'Sau (Ctrl + F8)',
    UnPostedTooltip: 'Bỏ ghi (Ctrl + G)',
    Utilities: 'Tiện ích',
    FilterBtn: 'Áp dụng',
    Process: 'Quy trình',
    Report: 'Báo cáo',
    ViewAllReport: 'Xem tất cả báo cáo',
    Phone: 'Điện thoại',
    IdentityNumber: 'Số CCCD',
    IdentityDate: 'Ngày cấp CMND',
    IdentityPlace: 'Nơi cấp',
    BudgetCode: 'Mã QHNS',
    Import: 'Nhập khẩu từ Excel',
    ViewVoucher: 'Xem chứng từ',
    AddVoucher: 'Thêm',
    AddVoucherTooltip: 'Thêm',
    Approve: 'Duyệt',
    UnApprove: 'Từ chối duyệt',
    ReceiveReport: 'Nhận báo cáo',
    SendRequest: 'Yêu cầu nộp',
    RegenerateData: 'Lấy lại dữ liệu',
    Download: 'Tải',
  },
  EventName: {
    CopyVoucher: 'Sao chép chứng từ',
    Delete: 'Xóa',
    View: 'Xem',
    Save: 'Cất',
    Accept: 'Đồng ý',
    SaveAdd: 'Cất và thêm mới',
    SaveClose: 'Cất và đóng',
    SaveView: 'Cất và xem',
    Edit: 'Sửa',
    Close: 'Đóng',
    Duplicate: 'Nhân bản',
    Add: 'Thêm mới',
    Active: 'Theo dõi',
    Unactive: 'Ngừng theo dõi',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi',
    Ok: 'In báo cáo',
    ViewReport: 'Xem báo cáo',
    Postpone: 'Hoãn',
    // NextVoucher: 'Trước',
    // BackVoucher: 'Sau',
    NextVoucher: 'Sau',
    BackVoucher: 'Trước',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
    NextStep: 'Tiếp tục',
    BackStep: 'Quay lại',
    SendApproval: 'Gửi duyệt',
    InsertRowGrid: 'Thêm dòng',
    DeleteRowGrid: 'Xóa dòng',
    Estimate: 'Nhập dự toán',
    Approve: 'Duyệt',
    Reject: 'Từ chối',
    UnApprove: 'Từ chối duyệt',
    SysRole: 'Phân quyền',
    SendNotify: 'Gửi thông báo cho khách hàng',
    SendInvoice: 'Gửi HĐ cho người mua',
    PublishInvoice: 'Phát hành HĐ',
    CreateSaleVoucher: 'Lập chứng từ bán hàng',
    ConvertToPaperVoucher: 'Chuyển thành HĐ giấy',
    DownloadInvoice: 'Tải HĐ',
    CancelInvoice: 'Hủy hóa đơn',
    SaleInvoiceReplace: 'Lập hóa đơn thay thế',
    CreateAdjustSaleInvoice: 'Lập hóa đơn điều chỉnh',
    PayTax: 'Nộp thuế',
    UpdateTaxIntoSalary: 'Cập nhật vào bảng lương',
    SalaryAllocation: 'Phân bổ nguồn',
    InvolveVoucher: 'Chứng từ liên quan',
    Cancel: 'Hủy bỏ',
    Load: 'Nạp',
    Stock: 'Nhập kho',
    Export: 'Xuất kho',
    Select: 'Chọn',
    Confirm: 'Xác nhận',
    BackToLogin: 'Quay lại đăng nhập',
    DownloadFile: 'Tải xuống',
    CreatVoucherInvoice: 'Lập chứng từ',
    UnChecked: 'Bỏ chọn',
    ChooseAll: 'Chọn tất cả',
    Undo: 'Hoàn tác',
    ReceiveReport: 'Nhận báo cáo',
    SendRequest: 'Yêu cầu nộp',
    // Ký số
    SendSignRequest: 'Gửi yêu cầu ký số',
    Sign: 'Ký số',
    RejectSign: 'Từ chối ký',
    AddSigner: 'Thêm người ký',
    CompleteSign: 'Hoàn thành yêu cầu ký số',
    DeleteSignRequest: 'Xóa yêu cầu ký số',
    // Báo cáo
    ViewReport: 'Xem báo cáo',
    CreateReport: 'Lập báo cáo',
    SubmitReport: 'Nộp báo cáo lên cấp trên',
    RetrieveReport: 'Thu hồi báo cáo',
    ReCreateReport: 'Lập lại báo cáo',
    SummarizeReport: 'Tổng hợp báo cáo',
    CancelSummarizeReport: 'Hủy tổng hợp báo cáo',
    ExportReport: 'Xuất khẩu báo cáo',
    GetData: 'Lấy dữ liệu xem báo cáo nhanh',
    // Biên lai
    SyncTicket: 'Lấy biên lai',
    CheckReplacedTicket: 'Kiểm tra biên lai đã thay thế',
    MarkPosted: 'Đánh dấu đã hạch toán',
    UnmarkPosted: 'Bỏ đánh dấu đã hạch toán',
    // Kết nối nền tảng số
    RejectPayment: 'Từ chối',
    SendFPT: 'Gửi tài liệu về ETCTHA',
    // Kho bạc điện tử
    CheckKBNNStatus: 'Kiểm tra trạng thái hồ sơ KBNN',
    ConnectDVCMultiBudgetCode: 'Kết nối DVC nhiều mã QHNS',
    // Hệ thống
    ChangeExecutor: 'Đồng ý Thay đổi CHV',
    CheckValidAmount: 'Kiểm tra tính hợp lệ của số dư',
    ImportData: 'Nhập khẩu chứng từ',
    CreateDatabase: 'Tạo mới dữ liệu',
    BackupData: 'Sao lưu dữ liệu',
    RestoreData: 'Phục hồi dữ liệu',
    CloseLedger: 'Khóa sổ kỳ kế toán',
    ReopenLedger: 'Bỏ khóa sổ kỳ kế toán',
    SaveSignature: 'Thiết lập/Sửa chữ ký số',
    ExportAccessHistory: 'Xuất khẩu nhật ký truy cập',
    // Kiểm kê
    AdjustInventory: 'Điều chỉnh chênh lệch kiểm kê',
    CancelAdjustInventory: 'Hủy điều chỉnh chênh lệch kiểm kê',
  },
  ScreenName: {
    Login: 'Đăng nhập',
    RoleManagement: 'Vai trò quyền hạn',
    CompanyInfo: 'Thông tin đơn vị',
    TransferExecutor: 'Chuyển chấp hành viên theo dõi QĐ thi hành án',

    //#region Tổng quan
    Dashboard: 'Tổng quan',
    //#endregion

    //#region Tiền mặt tại quỹ
    CashProcess: 'Quy trình tiền mặt tại quỹ',
    CashReceipt: 'Phiếu thu',
    CAReceipt: 'Phiếu thu',
    CashPayment: 'Phiếu chi',
    CAPayment: 'Phiếu chi',
    //#endregion

    //#region Tiền gửi ngân hàng
    DepositProcess: 'Quy trình tiền gửi ngân hàng',
    Cheque: 'Phát hành séc',
    Deposit: 'Nộp tiền vào ngân hàng',
    AccountDeposit: 'Nộp tiền vào ngân hàng',
    ChequeIssuance: 'Phát hành séc',
    //#endregion

    //#region Tài sản - tang vật
    AssetProcess: 'Quy trình tài sản tang vật',
    InventoryInInward: 'Phiếu nhập kho',
    InwardStock: 'Phiếu nhập kho',
    OutwardStock: 'Phiếu xuất kho',
    InventoryInOutward: 'Phiếu xuất kho',
    AssetTransfer: 'Chuyển kho',
    InTransfer: 'Chuyển kho',
    Inventory: 'Kiểm kê',
    InventoryCount: 'Kiểm kê',
    //#endregion

    //#region Phân phối
    DistributionProcess: 'Quy trình phân phối',
    AccountTransferSlipVoucher: 'Phiếu kết chuyển tài khoản',
    AccountTransferSlipVoucherDetail: 'Chi tiết phiếu kết chuyển tài khoản',
    AccountClosingVoucher: 'Phiếu kết chuyển tài khoản',
    VoucherList: 'Bảng tổng hợp chứng từ cùng loại',
    JusticeReceipt: 'Phân phối thu thi hành án',
    JusticeSelling: 'Phân phối tiền bán tài sản',
    //#endregion
    //#region Phân hệ tổng hợp toàn ngành
    ReceiveSubOrgReport: 'Nhận báo cáo cấp dưới',
    //#endregion
    //#region Sổ cái
    LedgerProcess: 'Quy trình sổ cái',
    SubmitReport: 'Nộp cấp trên',
    CashAndAssetDetermination: 'Phiếu xác định tiền, giá trị tài sản - tang vật',
    AssetEvaluation: 'Phiếu xác định tiền, giá trị tài sản - tang vật',
    OtherTransactionVoucher: 'Chứng từ nghiệp vụ khác',
    GeneralJournalEntry: 'Chứng từ nghiệp vụ khác',
    //#endregion

    //#region Biên lai
    Ticket: 'Biên lai',
    TicketList: 'Biên lai',
    //#endregion

    //#region Báo cáo
    Report: 'Báo cáo',
    //#endregion

    //#region Ký số
    DigitalSign: 'Ký số',
    //#endregion

    //#region Số dư ban đầu
    AccountBalanceTab: 'Số dư tài khoản',
    AssetAccountBalanceTab: 'Số dư tài sản và tang vật',
    ObjectAccountBalanceTab: 'Số dư theo đối tượng',
    BankAccountBalanceTab: 'Số dư tài khoản ngân hàng',
    ObjectAndDecisionAccountBalanceTab: 'Số dư theo đối tượng và quyết định',
    OtherAccountBalanceTab: 'Số dư tài khoản khác',

    //#endregion

    //#region Danh mục
    Dictionary: 'Danh mục',
    DiAsset: 'Tài sản/tang vật',
    DiAssetCategory: 'Loại tài sản/tang vật',
    DiReceipt: 'Mẫu số biên lai',
    DiAccountCategory: 'Nhóm tài khoản',
    DiStock: 'Kho',
    DiCurrency: 'Tiền tệ',
    DiBankInfo: 'Tài khoản ngân hàng',
    DiBankStandard: 'Ngân hàng/Kho bạc',
    DiAccount: 'Hệ thống tài khoản',
    DIAccountTransfer: 'Tài khoản kết chuyển',
    DIDefaultAccount: 'Tài khoản ngầm định',
    DIListCode: 'Mã thống kê',
    DIBranch: 'Đơn vị trực thuộc',
    DIAccountingObject: 'Đối tượng',
    DIJusticeCase: 'Bản án',
    DIJusticeCaseType: 'Loại bản án',
    DIJusticeDecesion: 'Quyết định thi hành án',
    DIJusticeDecesionGroup: 'Nhóm quyết định thi hành án',
    DIArea: 'Khu vực',
    DIGITAL_SIGN_PENDING_DOCUMENTS: 'Chứng từ chờ ký số',
    DIGITAL_SIGN_SIGNED_DOCUMENTS: 'Chứng từ đã ký số',
    //#endregion

    //#region Kết nối nền tảng số
    FptConnect: 'Kết nối nền tảng số',
    //#endregion

    //#region Kho bạc điện tử
    Etreasury: 'Kho bạc điện tử',
    ConnectDVCMultiBudgetCode: 'Kết nối DVC nhiều mã QHNS',
    //#endregion

    //#region Thiết lập chữ ký số
    SigningSetting: 'Thiết lập chữ ký số',
    //#endregion

    //#region Chuyển tài khoản hạch toán
    DIAccount: 'Chuyển tài khoản hạch toán',
    //#endregion

    //#region Thay đổi CHV
    ChangeObject: 'Thay đổi CHV',
    //#endregion

    //#region Nhật ký truy cập
    AccessHistory: 'Nhật ký truy cập',
    //#endregion

    //#region Người dùng
    UserManagement: 'Người dùng',
    //#endregion

    //#region Dữ liệu
    DataManagement: 'Quản lý dữ liệu',
    //#endregion

    //#region Kiểm tra
    CheckValidAmount: 'Kiểm tra tính hợp lệ của số dư',
    CheckValidVoucher: 'Kiểm tra chứng từ ghi sổ không hợp lệ',
    //#endregion

    //#region Dữ liệu hệ thống
    InfoData: 'Quản lý dữ liệu',
    //#endregion
  },

  SubSystemName: {
    Cash: 'Tiền mặt tại quỹ',
  },

  ButtonUtil: {
    Notifi: 'Thông báo',
    Dictionary: 'Danh mục',
    AddDictionary: 'Thêm mới Danh mục',
    DictionaryTab: {
      Stock: 'Thêm Kho',
    },
    DuplicateVoucher: 'Thêm mới từ chứng từ hiện thời',
    DuplicateVoucher_2: 'Thêm mới từ chứng từ hiện thời',
    InitBalance: 'Nhập số dư ban đầu',
    AddVoucher: 'Thêm chứng từ',
    CopyVoucher: 'Sao chép chứng từ',
    CopyVoucherOther: 'Sao chép từ chứng từ khác',
    SUSubmitReport: 'Nộp báo cáo cấp trên',
    CreateAccountTransfer: 'Sinh phiếu kết chuyển tài khoản',
    CreateAccountDeposit: 'Sinh phiếu nộp tiền kho bạc',
    CreateAccountWithdrawal: 'Sinh phiếu rút tiền kho bạc',
    CreatePayment: 'Sinh phiếu chi',
    GeneratePaymentVoucher: 'Sinh phiếu chi',
    GenerateSalaryPayment: 'Sinh phiếu chi trả lương',
    GenerateSalaryDepositsPayment: 'Sinh phiếu chi tiền gửi trả lương',
    CreateReceipt: 'Sinh phiếu thu',
    SearchByDepartmentInfo: 'Tìm kiếm theo Mã phòng, Tên phòng',
    CreateOutward: 'Sinh phiếu xuất kho',
    GenerateExpenseAccounting: 'Sinh hạch toán chi phí lương, bảo hiểm, KPCĐ',
    GeneratePaymentVoucher: 'Sinh phiếu chi tiền',
    ConcurrentAccounting: 'Lập bút toán đồng thời',
  },

  FilterGrid: {
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
  },

  VoucherList: {
    CashReceipt: 'Phiếu thu',
    CashPayment: 'Phiếu chi',
    Cheque: 'Phát hành séc',
    Deposit: 'Nộp tiền vào tài khoản',
    InwardStock: 'Phiếu nhập kho',
    OutwardStock: 'Phiếu xuất kho',
    AccountTransferSlipVoucher: 'Phiếu kết chuyển tài khoản',
    GeneralJournalEntry: 'Chứng từ nghiệp vụ khác',
    AssetEvaluation: 'Phiếu xác định tiền, giá trị TSTV'
  }
};
